import { styled } from '@mui/material/styles';
import React from 'react';
import { TABLET_SCREEN_SIZE, SMALL_TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { BrandclubProductCard } from '../components/BrandclubProductCard/index.js';
import { useRecommendedProducts } from './useRecommendedProducts.js';

var _a, _b;
var CardGrid = styled('div')((_a = {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        justifyContent: 'space-between',
        gridGap: 20
    },
    _a["@media screen and (max-width: ".concat(1250, "px)")] = {
        gridTemplateColumns: 'repeat(4, 1fr)',
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        gridTemplateColumns: 'repeat(3, 1fr)',
    },
    _a["@media screen and (max-width: ".concat(SMALL_TABLET_SCREEN_SIZE, "px)")] = {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridGap: 10,
    },
    _a));
var CardGridSkeleton = styled(CardGrid)((_b = {
        gridTemplateRows: 'repeat(1, 1fr)',
        gridAutoRows: '0',
        overflowY: 'hidden',
        height: 400
    },
    _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        height: 280,
    },
    _b));
var StyledHeader = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '10px',
        marginBottom: '37px',
        color: theme.palette.primary.main,
    });
});
var LoadingCardGridSkeleton = function () {
    return (React.createElement(CardGridSkeleton, null, Array.from({ length: 5 }).map(function (_, i) {
        var _a;
        return (React.createElement(Skeleton, { key: i, variant: "rectangular", width: "100%", height: "100%", sx: (_a = {
                    bgcolor: '#f6f8fa'
                },
                _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                    height: 280,
                    borderRadius: 12,
                    marginBottom: '20px',
                },
                _a) }));
    })));
};
var LoadingHeaderSkeleton = function () {
    return (React.createElement(StyledHeader, null,
        React.createElement(Skeleton, { variant: "text", width: 200, height: 40, sx: { bgcolor: '#f6f8fa' } }),
        React.createElement(Skeleton, { variant: "text", width: 100, height: 40, sx: { bgcolor: '#f6f8fa' } })));
};
var Header = function (props) {
    return (React.createElement(StyledHeader, { display: "flex", flexDirection: "column", width: "100%", gap: "10px", marginBottom: "37px", color: function (theme) { return theme.palette.primary.main; } },
        React.createElement(Box, { fontWeight: 700, fontSize: 24 }, props.title),
        React.createElement(Box, { fontSize: 16, fontWeight: 500 }, props.subtitle)));
};
var RecommendedProducts = function (props) {
    var _a;
    var title = props.title || 'You may also like';
    var subtitle = props.subtitle || 'Similar products picked for you';
    var apolloClient = props.apolloClient, product = props.product, isUserSignedIn = props.isUserSignedIn;
    var _b = useRecommendedProducts({ apolloClient: apolloClient, product: product, isUserSignedIn: isUserSignedIn }), loading = _b.loading, recommendedProducts = _b.recommendedProducts;
    if (!loading && !(recommendedProducts === null || recommendedProducts === void 0 ? void 0 : recommendedProducts.length)) {
        // No recommended products
        return null;
    }
    return (React.createElement(Box, { paddingTop: "50px", sx: (_a = {},
            _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                margin: '0 20px',
            },
            _a) }, loading || !recommendedProducts ? (React.createElement(React.Fragment, null,
        React.createElement(LoadingHeaderSkeleton, null),
        React.createElement(LoadingCardGridSkeleton, null))) : (React.createElement(React.Fragment, null,
        React.createElement(Header, { title: title, subtitle: subtitle }),
        React.createElement(CardGrid, null, recommendedProducts.map(function (p) { return (React.createElement(BrandclubProductCard, { key: "trending:".concat(p.stacklineSku), LinkComponent: props.linkComponent, product: p })); }))))));
};

export { RecommendedProducts };
//# sourceMappingURL=index.js.map
